module.exports = ({React,connect,DataGrid,collectionSearch,EventActions})->#
  
  {eventsAreSelected} = EventActions

  class EventList extends React.Component

    render:->
      <div style={{ height: '100%' }}>
        <DataGrid 
          rows={@props.events} 
          selected={@props.eventsSelected}
          columns={[
            {label:"Name",field:"name",width:400},
            {label:"Description",field:"description",width:300},
            {label:"Link",field:"link",width:300},
            {label:"Published",field:"publish",width:70,type:"tick"},
            {label:"Start Date",field:"start_date",width:100,type:"date"},
            {label:"End Date",field:"end_date",width:100,type:"date"},
            {label:"Salesforce",field:"reference",width:200},
          ]} 
          onRowClick={(selectedRows)=> @props.dispatch(eventsAreSelected(selectedRows))}
          onRowDoubleClick={(selectedRows)=> @props.onEdit()} />
        {if @props.eventsAreLoading 
          <div className="react-grid-FooterRow"><span className="fa fa-refresh fa-spin" /> Loading Events</div>
        else
          <div className="react-grid-FooterRow">{@props.events.length} Events</div>
        } 
      </div>

  return connect(
    (state)=>
      eventsSelected: state.eventsSelected,
      eventsAreLoading: state.eventsAreLoading,
      events: collectionSearch(state.events,{},state.eventsSearchTerm)
    )(EventList)